/**
 * F3. Торг: продавец просит цену, у игрока 3 попытки сбить ползунком.
 * Ответ продавца экран знает сам (порог согласия и порог ухода в
 * состоянии, без жребия): согласился — сделка, ниже порога ухода — ушёл,
 * между — «качает головой». Все предложения уходят в логику разом.
 */
import { t } from '@life/i18n';
import type { BargainInput, BargainState } from '@life/minigames';
import { useState } from 'preact/hooks';
import { money } from '../lib/format';
import type { MinigameScreenProps } from './types';

export function Bargain({ state, onInput }: MinigameScreenProps<BargainInput, BargainState>) {
  const top = Math.max(0, Math.floor(state.price));
  const [offer, setOffer] = useState(() => Math.floor(top * 0.8));
  const [offers, setOffers] = useState<number[]>([]);
  const left = state.tries - offers.length;

  const propose = () => {
    const next = [...offers, offer];
    const settled = offer >= state.floor || offer < state.walkAway || next.length >= state.tries;
    if (settled) {
      onInput({ offers: next });
      return;
    }
    setOffers(next);
  };

  return (
    <>
      <p class="hint">{t('ui.minigame.bargain.price', { sum: money(state.price) })}</p>
      <p class="hint">{t('ui.minigame.bargain.zone', { p: Math.round(state.zone * 100), n: state.tries })}</p>
      {offers.length > 0 && <p class="hint mono">{t('ui.minigame.bargain.again', { n: left })}</p>}
      <div class="bet">
        <label>
          <span>{t('ui.minigame.bargain.offer')}</span>
          <span class="mono">{money(offer)}</span>
        </label>
        <input
          type="range"
          min={0}
          max={top}
          step={1}
          value={offer}
          disabled={top <= 0}
          aria-label={t('ui.minigame.bargain.offer')}
          aria-valuetext={money(offer)}
          onInput={(e) => setOffer(Number((e.currentTarget as HTMLInputElement).value))}
        />
      </div>
      <button type="button" class="btn accent block" disabled={top <= 0} onClick={propose}>
        {t('ui.minigame.bargain.send', { n: left })}
      </button>
    </>
  );
}
